import React, { useState, Fragment } from 'react';
import FavoriteIcon from '@material-ui/icons/Favorite';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    flexGrow: 1,
  },
  cardHeader: {
    paddingBottom: 0
  }
}));

const options = [
  'Edit',
  'Delete',
];

export default function ViewDetailsCard({ ...props }) {
  const {
    currentUser,
    setInEditMode,
    handleFavorite,
    setIsSnackbarOpen,
    setSnackbarVariant,
    setSnackbarMessage,
    favorited,
    family } = props;
  const {
    id,
    lastName,
    adults,
    dependents,
    address,
    province,
    postal,
    city,
    emails,
    phones } = family;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const cardTitle = adults.length === 1 ? 
    `${adults[0]} ${lastName}` : 
    `${adults[0]} and ${adults[1]} ${lastName}`;

  const avatarStyle = () => {
    const ascii = (c) => c.charCodeAt(0);
    const reducer = (accumulator, currentValue) => accumulator + ascii(currentValue);
    const r = adults[0].split('').reduce(reducer, 0) % 255;
    const g = lastName.split('').reduce(reducer, 0) % 255;
    const b = id.split('').reduce(reducer, 0) % 255;
    return { backgroundColor: `rgb(${r},${g},${b})` };
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (option) => {
    switch (option) {
      case 'Edit':
        setInEditMode(true);
        break;
      case 'Delete':
        setSnackbarVariant('info');
        setSnackbarMessage('This feature has been disabled');
        setIsSnackbarOpen(true);        

        break;
      default:
        console.debug("unknown option", option);
    }
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Grid item xs={12} sm={6} md={4}>
        <Card className={classes.card}>
          <CardHeader
            titleTypographyProps={{variant:'subtitle2'}}
            avatar={
              <Avatar aria-label="recipe" style={avatarStyle()}>
                {lastName[0]}
              </Avatar>
            }
            action={
              <Fragment>
                <IconButton 
                  aria-label="settings"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    style: {
                      width: 100,
                    },
                  }}
                >
                  {options.map(option => {
                    if (option === 'Delete') {
                      if (currentUser.id === family.id || currentUser.role === 'admin') {
                        return (
                          <MenuItem key={option} onClick={() => handleClose(option)}>
                            {option}
                          </MenuItem>
                        )
                      }
                    }
                    return (
                      <MenuItem key={option} onClick={() => handleClose(option)}>
                        {option}
                      </MenuItem>
                    )
                  })}
                </Menu>
              </Fragment>
            }
            title={cardTitle}
            subheader={dependents.join()}
          />
          <CardContent className={classes.cardContent}>
            <Link href={`http://maps.google.com/?q=${address}, ${city}, ${province}, ${postal}`}>
              <Typography variant="body2" component="p">
                {address}
              </Typography>
              <Typography variant="body2" component="p">
                {city}, {province}, {postal}
              </Typography>
            </Link>
            <br />
            
              <Typography variant="body2" component="p">
                {adults[0]}'s email: <Link href={`mailto:${emails[0]}`}>{emails[0]}</Link>
              </Typography>
            {
              adults[1] && 
                <Typography variant="body2" component="p">
                  {adults[1]}'s email: <Link href={`mailto:${emails[1]}`}>{emails[1]}</Link>
                </Typography>
            }
            <Typography variant="body2" component="p">
              {adults[0]}'s phone: <Link href={`tel:${phones[0]}`}>{phones[0]}</Link>
            </Typography>
            {
              adults[1] && 
              <Typography variant="body2" component="p">
                {adults[1]}'s phone: <Link href={`tel:${phones[1]}`}>{phones[1]}</Link>
              </Typography>
            }
          </CardContent>
          <CardActions>
            <IconButton
              aria-label="add to favorites"
              onClick={() => handleFavorite(id, favorited)}
            >
              <FavoriteIcon color={favorited ? 'secondary' : 'action'} />
            </IconButton>
          </CardActions>
        </Card>
      </Grid>
    </React.Fragment>
  )
}